// extracted by mini-css-extract-plugin
export default {"Company":"company_Company__OSC0S"};